// Tính "đang mở cửa" theo giờ Việt Nam cố định (Asia/Ho_Chi_Minh), không phụ thuộc
// múi giờ của máy chạy (server build/ISR thường là UTC, máy khách có thể ở nước ngoài).
export const SHOP_TIME_ZONE = "Asia/Ho_Chi_Minh";

/** "9:00" / "09:00" -> số phút từ 0h (null nếu không parse được) */
export const toMinutes = (hour?: string): number | null => {
  if (!hour) return null;
  const m = /^(\d{1,2}):(\d{2})/.exec(hour.trim());
  if (!m) return null;
  return Number(m[1]) * 60 + Number(m[2]);
};

/** Số phút từ 0h theo giờ VN của thời điểm `date` */
export const vnMinutesOfDay = (date: Date = new Date()): number => {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: SHOP_TIME_ZONE,
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const get = (type: string) => Number(parts.find((p) => p.type === type)?.value || 0);
  return get("hour") * 60 + get("minute");
};

/** true/false = mở/đóng; null = không đủ dữ liệu giờ để kết luận */
export const isShopOpenNow = (
  openHour?: string,
  closeHour?: string,
  isClosed = false,
  date: Date = new Date(),
): boolean | null => {
  if (isClosed) return false;
  const open = toMinutes(openHour);
  const close = toMinutes(closeHour);
  if (open === null || close === null) return null;
  const cur = vnMinutesOfDay(date);
  // Qua nửa đêm (vd 18:00 - 02:00)
  return close < open ? cur >= open || cur < close : cur >= open && cur < close;
};
